import { GET_USERS, useUserCreate } from "@ticketingplatform/api/dist/users";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Form, message } from "antd";
import { ROUTE_PATHS } from "const/paths";
import { useMemo } from "react";
import useApolloErrorFields from "hooks/useApolloErrorFields";
import usePrompt from "hooks/usePrompt";

import { UserFormProps } from "../UserForm/types";

import { USER_INITIAL_VALUES } from "./consts";

export const useAddUserForm = (): UserFormProps<false> => {
  const [form] = Form.useForm();
  const [createUser, { error, loading }] = useUserCreate({
    evictQueries: [GET_USERS],
  });
  const intl = useIntl();
  const navigate = useNavigate();
  const fields = useApolloErrorFields(error);

  usePrompt(loading);

  return useMemo(
    () => ({
      loading,
      form,
      fields,
      initialValues: USER_INITIAL_VALUES,
      async onFinish({ input }) {
        try {
          await createUser({
            variables: {
              input,
            },
          });

          message.success(
            intl.formatMessage({
              defaultMessage: "User has been added!",
            })
          );

          navigate(ROUTE_PATHS.SettingsUsers, {
            state: {
              skipBlock: true,
            },
          });
        } catch {
          message.error(
            intl.formatMessage({
              defaultMessage: "Error. Cannot add User.",
            })
          );
        }
      },
    }),
    [createUser, fields, form, intl, loading, navigate]
  );
};
